module.exports = __webpack_public_path__ + "static/media/info_icon.0df2aa8d.svg";